import { render, staticRenderFns } from "./modal-participant-approval.vue?vue&type=template&id=21f4f54c&scoped=true"
import script from "./modal-participant-approval.vue?vue&type=script&lang=js"
export * from "./modal-participant-approval.vue?vue&type=script&lang=js"
import style0 from "./modal-participant-approval.vue?vue&type=style&index=0&id=21f4f54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4f54c",
  null
  
)

export default component.exports